<template>
  <div class="pay-success" style="padding-top: 44px;">
    <back-header title="支付" />
    <img src="./bg@2x.png" alt="">
    <h6>支付成功</h6>
    <p>商家将尽快为您发货</p>
  </div>
</template>

<script>
import BackHeader from '../../components/back-header/back-header'
export default {
  name: 'pay-success',
  components: {
    BackHeader
  }
}
</script>

<style scoped lang="stylus">
.pay-success
  text-align center
  &>img
    padding-top 125px
    width 490px
    height 502px
  &>h6
    margin-top 50px
    margin-bottom 31px
    font-size 34px
    color #070707
  &>p
    font-size 30px
    color #9B9B9B
</style>
